import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import { Dropdown } from '../dropdown/dropdown';
import { _$ } from '../../i18n';
import { themes } from './styles';
var typeDefs = _extends({}, Dropdown.typeDefs, {
  showArrow: Boolean,
  theme: themes,
  hoverable: Boolean,
  always: Boolean,
  confirm: Boolean,
  okText: String,
  cancelText: String,
  size: ['small', 'default'],
  content: null
});
var defaults = function defaults() {
  return _extends({}, Dropdown.defaults(), {
    showArrow: true,
    theme: 'dark',
    position: {
      my: 'center bottom-10',
      at: 'center top',
      collision: 'flipfit'
    },
    collison: 'flipfit',
    hoverable: false,
    always: false,
    confirm: false,
    okText: _$('确定'),
    cancelText: _$('取消'),
    size: 'default'
  });
};
var events = _extends({}, Dropdown.events, {
  ok: true,
  cancel: true
});
export var Tooltip = /*#__PURE__*/function (_Dropdown) {
  _inheritsLoose(Tooltip, _Dropdown);
  function Tooltip() {
    return _Dropdown.apply(this, arguments) || this;
  }
  var _proto = Tooltip.prototype;
  _proto.show = function show(shouldFocus) {
    if (shouldFocus === void 0) {
      shouldFocus = false;
    }
    if (this.get('disabled')) return;
    clearTimeout(this.timer);
    this.set('value', true);
  };
  _proto.hide = function hide(immediately) {
    if (this.get('always')) return;
    if (this.get('hoverable')) {
      return _Dropdown.prototype.hide.call(this, immediately);
    }
    // tooltip can show any number sub-tooltips, we should not close the showed tooltip
    // #885
    this.showedDropdown = null;
    _Dropdown.prototype.hide.call(this, true);
  };
  return Tooltip;
}(Dropdown);
Tooltip.typeDefs = typeDefs;
Tooltip.defaults = defaults;
Tooltip.events = events;